import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../components/modal/Modal";
import Table from "../../components/table/Table";
import {
  addEditedInvoice,
  clearEditInvoice,
  fetchAllSales,
  updateInvoiceStatus,
} from "../../redux/features/sales.features";
import EditInvoice from "./EditInvoice";
import IndividualInvoiceViewer from "./IndividualInvoiceViewer";
import InvoiceViewer from "./InvoiceViewer";
import moment from 'moment'
import { Tooltip } from "@mui/material";

const Tab = ({ title, icon, activeIndex, index, onClick }) => (
  <div
    onClick={onClick}
    className="flex items-center p-3 mx-2 font-extrabold uppercase cursor-pointer bg-slate-500 hover:bg-slate-800"
    style={{
      boxShadow: "var(--box-shadow)",
      background: activeIndex === index ? "var(--main-color)" : "",
    }}
  >
    <i className="px-2">{icon}</i> {title}
  </div>
);
//invoice Table
const invoiceTableHead = [
  "",
  "invoice-no",
  "customer",
  "date",
  "type", //sales //on-approval
  "payment type", //cash //credit
  "sub total",
  "discount",
  "grand total",
  "balance to received",
  "balance to customer",
  "payment status",
  
];

const InvoiceList = () => {
  let salesState = useSelector((state) => {
    return state.salesReducer;
  });
  let { recentInvoice, invoice, sales, successMessage, errorMessage } =
    salesState;

    let userState = useSelector((state) => {
      return state.userReducer;
    });
  
    let { user} = userState;

  const dispatch = useDispatch();
  const [tab, setTab] = useState(1);
  const [selectedInvoice, setselectedInvoice] = useState(null);
  const [showIndividualInvoiceViewerModal, setIndividualInvoiceShow] =
    useState(false);
  const [showInvoiceEditingModal, setShowInvoiceEditingModal] = useState(false);
  const [TotalOnApprovalAmountLKR, setTotalOnApprovalAmountLKR] = useState(0);
  const [TotalOnApprovalAmountToReceiveLKR, setTotalOnApprovalAmountToReceiveLKR] = useState(0);
  const [TotalOnApprovalAmountUSD, setTotalOnApprovalAmountUSD] = useState(0);

  const onViewInvoice = (item) => {
    setselectedInvoice(item);
    setIndividualInvoiceShow(true);
  };

  const changeToComplete = (item) => {

    if(Number(item.invoiceBalanceToReceived) !== 0  ) return alert("Cannot change the status into Complete due to the invoice payments are not fully paid")

    const data = {
      id:item.id,
      invoiceStatus: "Complete",
    };
    dispatch(updateInvoiceStatus(data));
  };
  const changeToPending = (item) => {

    if(Number(item.invoiceBalanceToReceived) === 0  ) return alert("Cannot change the status into Payment Pending due to the invoice payments are already fully paid")

    const data = {
      id:item.id,
      invoiceStatus: "PaymentPending",
    };
    dispatch(updateInvoiceStatus(data));
  };

  const onClickEditedInvoice = (data) => {
    let copyObj = {};
    for (let i in data) {
      copyObj[i] = data[i];
    }
    dispatch(addEditedInvoice(copyObj));
    setShowInvoiceEditingModal(true);
  };

  const renderHead = (item, index) => <th key={index}>{item}</th>;

  const renderBody = (item, index) => (
    <tr key={index}>
       <td className="flex justify-start items-center">
        <div
          onClick={() => onClickEditedInvoice(item)}
          className="bg-red-500 rounded p-2 bx bx-edit mx-1 text-white"
        ></div>
        <div
          onClick={() => {
            onViewInvoice(item);
          }}
          className="bg-green-500 rounded p-2 bx bx-show mx-1 text-white"
        ></div>
        {/* <div
          onClick={() => {
            alert("this function is coming soon")
          }}
          className="bg-blue-500 rounded p-2 bx bx-trash mx-1 text-white"
        ></div> */}

{
         sales[0] === item &&  (<div onClick={()=> alert("this features is coming soon")} className="bg-purple-500 rounded p-2 bx bx-trash mx-2  text-white"></div>)
        }


      </td>
      {/* <td>{item.id}</td> */}
      <td>{item.invoiceNumber}</td>
      <td>
      {item.invoiceType === "Sales" ? (
        <span>
        {item.invoiceCustomer &&
          item.invoiceCustomer.length !== 0 &&
          user.role === "admin"
            ? item.invoiceCustomer[0].firstName
            : item.invoiceCustomer[0].customerId}
            </span>
      ) : (
        <span>
        {item.invoiceBroker &&
          item.invoiceBroker.length !== 0 &&
          item.invoiceBroker[0].firstName}
          </span>
      )
        }
      </td>
      <td>{moment(item.invoiceDate).format("DD-MM-YYYY")}</td>
      <td>
        {" "}
        <div
          className={`rounded p-2 bg-${
            item.invoiceType === "Sales" ? "green" : "red"
          }-600`}
        >
          {item.invoiceType}{" "}
        </div>{" "}
      </td>
      <td>{item.invoicePaymentType}</td>

      <td>
        {Number(item.invoiceSubTotal).toLocaleString()} {item.invoiceCurrency}
      </td>
      <td>
        {Number(item.invoiceDiscountAmount).toLocaleString()}{" "}
        {item.invoiceCurrency}
      </td>
      <td>
        {Number(item.invoiceGrandTotal).toLocaleString()} {item.invoiceCurrency}
      </td>
      <td>
        {Number(item.invoiceBalanceToReceived).toLocaleString()}{" "}
        {item.invoiceCurrency}
      </td>
      <td>
        {Number(item.invoiceBalanceToCustomer).toLocaleString()}{" "}
        {item.invoiceCurrency}
      </td>

      <td className="">
        {item.invoiceStatus}
        {item.invoiceStatus !== "Complete" &&
          item.invoiceStatus !== "Return" &&
          item.invoiceStatus !== "Cancel" && (
            <div className="flex w-full">
              <Tooltip title="Payments are fully completed" > 
  

               <i
                onClick={() => changeToComplete(item)}
                className="w-full bg-green-500 m-2 p-2 text-xs font-extrabold text-white rounded"
              >
                CML
                </i>
                </Tooltip>
                <Tooltip title="Payments are pending" >
                  <i
                onClick={() => changeToPending(item)}
                className="w-full bg-red-500 m-2 p-2 text-xs font-extrabold text-white rounded"
              >
                PND
                </i>
                </Tooltip>
            </div>
          )}
      </td>
     
    </tr>
  );
  const invoiceList = (status, type) => {
    let invoices = sales;
    if (status && invoices && invoices.length !== 0) {
      invoices = invoices.filter((x) => x.invoiceStatus === status);
    }
    if (type && invoices && invoices.length !== 0) {
      invoices = invoices.filter((x) => x.invoiceType === type);
    }

    return (
      <div className="w-full overflow-x-scroll p-4">
        <Table
        showSearch
        showLimit
          limit="10"
          headData={invoiceTableHead}
          renderHead={(item, index) => renderHead(item, index)}
          bodyData={invoices}
          renderBody={(item, index) => renderBody(item, index)}
        />
      </div>
    );
  };

  useEffect(() => {
    dispatch(fetchAllSales());
  }, [dispatch]);
  useEffect(() => {
    let totalAmountLKR = 0;
    let totalAmountUSD = 0;
    let totalAmountToReceiveLKR = 0;
    let onApprovalsLKR = (sales || [])
      .filter((x) => x.invoiceType !== "Sales" && x.invoiceCurrency === "LKR")
    
      onApprovalsLKR.map((y) => {
        return (totalAmountLKR += Number(y.invoiceGrandTotal));
      });
      onApprovalsLKR.map((y) => {
        return (totalAmountToReceiveLKR += Number(y.invoiceBalanceToReceived));
      });

    (sales || [])
      .filter((x) => x.invoiceType !== "Sales" && x.invoiceCurrency === "USD")
      .map((y) => {
        return (totalAmountUSD += Number(y.invoiceGrandTotal));
      });

    setTotalOnApprovalAmountLKR(totalAmountLKR);
    setTotalOnApprovalAmountUSD(totalAmountUSD);
    setTotalOnApprovalAmountToReceiveLKR(totalAmountToReceiveLKR);
  }, [sales, tab]);

  return (
    <div className="flex flex-col w-full h-full ">
      <div className="flex p-2 ">
        <Tab
          activeIndex={tab}
          index={1}
          onClick={() => {
            setTab(1);
          }}
          icon={<i className="bx bx-cog" />}
          title={`Not Approved (${
            sales.filter((x) => x.invoiceStatus === "NotApproved").length
          })`}
        />
        <Tab
          activeIndex={tab}
          index={2}
          onClick={() => {
            setTab(2);
          }}
          icon={<i className="bx bx-user" />}
          title={`Payment Complete (${
            sales.filter((x) => x.invoiceStatus === "Complete").length
          })`}
        />
        <Tab
          activeIndex={tab}
          index={3}
          onClick={() => {
            setTab(3);
          }}
          icon={<i className="bx bxs-bank" />}
          title={`Payment Pending (${
            sales.filter((x) => x.invoiceStatus === "PaymentPending").length
          })`}
        />
        <Tab
          activeIndex={tab}
          index={4}
          onClick={() => {
            setTab(4);
          }}
          icon={<i className="bx bx-receipt" />}
          title={`Return (${
            sales.filter((x) => x.invoiceStatus === "Return").length
          })`}
        />
        <Tab
          activeIndex={tab}
          index={5}
          onClick={() => {
            setTab(5);
          }}
          icon={<i className="bx bx-detail" />}
          title={`Cancel (${
            sales.filter((x) => x.invoiceStatus === "Cancel").length
          })`}
        />
        <Tab
          activeIndex={tab}
          index={6}
          onClick={() => {
            setTab(6);
          }}
          icon={<i className="bx bx-detail" />}
          title={`All Sales (${
            sales.filter((x) => x.invoiceType === "Sales").length
          })`}
        />
        <Tab
          activeIndex={tab}
          index={7}
          onClick={() => {
            setTab(7);
          }}
          icon={<i className="bx bx-detail" />}
          title={`All On Approvals (${
            sales.filter((x) => x.invoiceType !== "Sales").length
          })`}
        />
        <Tab
          activeIndex={tab}
          index={8}
          onClick={() => {
            setTab(8);
          }}
          icon={<i className="bx bx-detail" />}
          title={`All (${sales.length})`}
        />
      </div>
      <div className="flex-1 border border-red-400"></div>

      {/* TABS CONTENT*/}

      {tab === 1 && (
        <div
          style={{ background: "var(--main-bg)" }}
          className="flex flex-wrap my-5 p-5"
        >
          <div className="w-full uppercase font-extrabold text-3xl flex">
            Not Approved invoices
          </div>
          {invoiceList("NotApproved")}
        </div>
      )}
      {tab === 2 && (
        <div
          style={{ background: "var(--main-bg)" }}
          className="flex flex-wrap my-5 p-5"
        >
          <div className="w-full uppercase font-extrabold text-3xl flex">
            Payment Completed invoices
          </div>
          {invoiceList("Complete")}
        </div>
      )}
      {tab === 3 && (
        <div
          style={{ background: "var(--main-bg)" }}
          className="flex flex-wrap my-5 p-5"
        >
          <div className="w-full uppercase font-extrabold text-3xl flex">
            Payment PaymentPending invoices
          </div>
          {invoiceList("PaymentPending")}
        </div>
      )}
      {tab === 4 && (
        <div
          style={{ background: "var(--main-bg)" }}
          className="flex flex-wrap my-5 p-5"
        >
          <div className="w-full uppercase font-extrabold text-3xl flex">
            Return invoices
          </div>
          {invoiceList("Return")}
        </div>
      )}
      {tab === 5 && (
        <div
          style={{ background: "var(--main-bg)" }}
          className="flex flex-wrap my-5 p-5"
        >
          <div className="w-full uppercase font-extrabold text-3xl flex">
            Cancel invoices
          </div>
          {invoiceList("Cancel")}
        </div>
      )}
      {tab === 6 && (
        <div
          style={{ background: "var(--main-bg)" }}
          className="flex flex-wrap my-5 p-5"
        >
          <div className="w-full uppercase font-extrabold text-3xl flex">
            ALL invoices
          </div>
          <div className="w-full uppercase font-extrabold text-3xl flex justify-evenly">
            <div className="flex-col flex-wrap p-3">
              <div className="">
                Total Sales :{" "}
                {sales.filter((x) => x.invoiceType === "Sales").length}
              </div>
              <div className="uppercase font-extrabold text-xl">
                USD SALES COUNT :{" "}
                {
                  sales.filter(
                    (x) =>
                      x.invoiceType === "Sales" && x.invoiceCurrency === "USD"
                  ).length
                }
              </div>
              <div className="uppercase font-extrabold text-xl">
                LKR SALES COUNT :{" "}
                {
                  sales.filter(
                    (x) =>
                      x.invoiceType === "Sales" && x.invoiceCurrency === "LKR"
                  ).length
                }
              </div>
            </div>
          </div>
          {invoiceList(undefined, "Sales")}
        </div>
      )}
      {tab === 7 && (
        <div
          style={{ background: "var(--main-bg)" }}
          className="flex flex-wrap my-5 p-5"
        >
          <div className="w-full uppercase font-extrabold text-3xl flex">
            ALL On Approvals -{" "}
            {(sales || []).filter((x) => x.invoiceType !== "Sales").length}
          </div>
          <div className=" w-full uppercase  font-extrabold text-3xl flex justify-evenly m-3">
            <div className="w-6/12 border border-1 m-3 flex-col p-3">
              <div>
                USD SALES -{" "}
                {
                  (sales || []).filter(
                    (x) =>
                      x.invoiceType !== "Sales" && x.invoiceCurrency === "USD"
                  ).length
                }
              </div>
              <div className="uppercase font-extrabold text-xl flex">
                <div className="py-2">Total USD Sales :</div>

                <i className="p-2">
                  {TotalOnApprovalAmountUSD.toLocaleString()} USD
                </i>
              </div>
            </div>
            <div className="w-6/12 border border-1 m-3 flex-col p-3">
              <div>
                LKR SALES -{" "}
                {
                  (sales || []).filter(
                    (x) =>
                      x.invoiceType !== "Sales" && x.invoiceCurrency === "LKR"
                  ).length
                }
              </div>
              <div className="uppercase font-extrabold text-xl flex justify-between">
                <div className="py-2">Total LKR Sales Amount :</div>

                <i className="p-2">
                  {TotalOnApprovalAmountLKR.toLocaleString()} LKR
                </i>
              </div>
              <div className="uppercase font-extrabold text-xl flex justify-between">
                <div className="py-2">Total RECEIVED :</div>

                <i className="p-2">
                  {Number(TotalOnApprovalAmountLKR - TotalOnApprovalAmountToReceiveLKR).toLocaleString()} LKR
                </i>
              </div>
              <div className="uppercase font-extrabold text-xl flex justify-between">
                <div className="py-2">Total BALANCE TO RECEIVE :</div>

                <i className="p-2">
                  {TotalOnApprovalAmountToReceiveLKR.toLocaleString()} LKR
                </i>
              </div>
            </div>
          </div>
          {invoiceList(undefined, "OnApproval")}
        </div>
      )}
      {tab === 8 && (
        <div
          style={{ background: "var(--main-bg)" }}
          className="flex flex-wrap my-5 p-5"
        >
          <div className="w-full uppercase font-extrabold text-3xl flex">
            ALL invoices
          </div>
          <div className="w-full uppercase font-extrabold text-3xl flex justify-evenly">
            <div className="flex-col flex-wrap">
              <div className="">Total Sales : {sales.length}</div>
              <div className="uppercase font-extrabold text-xl">
                USD SALES COUNT :{" "}
                {
                  sales.filter(
                    (x) =>
                      x.invoiceType === "Sales" && x.invoiceCurrency === "USD"
                  ).length
                }
              </div>
              <div className="uppercase font-extrabold text-xl">
                LKR SALES COUNT :{" "}
                {
                  sales.filter(
                    (x) =>
                      x.invoiceType === "Sales" && x.invoiceCurrency === "LKR"
                  ).length
                }
              </div>
            </div>
            <div className="flex-col flex-wrap">
              <div className="">Total on Approvals : {sales.length}</div>
              <div className="uppercase font-extrabold text-xl">
                USD SALES COUNT :{" "}
                {
                  sales.filter(
                    (x) =>
                      x.invoiceType === "Sales" && x.invoiceCurrency === "USD"
                  ).length
                }
              </div>
              <div className="uppercase font-extrabold text-xl">
                LKR SALES COUNT :{" "}
                {
                  sales.filter(
                    (x) =>
                      x.invoiceType === "Sales" && x.invoiceCurrency === "LKR"
                  ).length
                }
              </div>
            </div>
          </div>
          {invoiceList()}
        </div>
      )}

      {/* modals */}

      <Modal
        modal_title={"INVOICE VIEWER"}
        canShow={showIndividualInvoiceViewerModal}
        updateModalState={() => {
          setIndividualInvoiceShow(false);
        }}
      >
        <Box>
          <IndividualInvoiceViewer invoice={selectedInvoice} />
        </Box>
      </Modal>

      <Modal
        modal_title={"Edit Invoice"}
        canShow={showInvoiceEditingModal}
        updateModalState={() => {
          setShowInvoiceEditingModal((state) => !state);
        }}
      >
        <Box>
          <EditInvoice
            cancel={() => {
              setShowInvoiceEditingModal((state) => !state);
              dispatch(clearEditInvoice());
            }}
           onClose= {() => {
              setShowInvoiceEditingModal((state) => !state);
              dispatch(clearEditInvoice());
            }}
          />
        </Box>
      </Modal>
    </div>
  );
};

export default InvoiceList;
